export type EditorColorTheme = {
    name:string,
    primary:string,
    highlight:string,
}

export const EditorColorThemes:EditorColorTheme[] = [
{
    name:"Green",
    primary:"#3E8438",
    highlight:"#3f6d3b"
},
{
    name:"Blue",
    primary:"#009dff",
    highlight:"#8bd2fe"
},
{
    name:"Red",
    primary:"#da2b2b",
    highlight:"#e87878"
},
{
    name:"Violet",
    primary:"#d33bf1",
    highlight:"#e67efb"
},
{
    name:"Orange",
    primary:"#f1a90e",
    highlight:"#ffd375"
},
{
    name:"Tan",
    primary:"#a1977d",
    highlight:"#bfb69f"
},


]
